import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { I18nProvider } from "@/i18n";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Customers from "@/pages/Customers";
import Products from "@/pages/Products";
import DocumentList from "@/pages/DocumentList";
import DocumentForm from "@/pages/DocumentForm";
import DocumentView from "@/pages/DocumentView";
import Settings from "@/pages/Settings";
import PaymentResult from "@/pages/PaymentResult";

function App() {
  return (
    <div className="App">
      <I18nProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/customers" element={<Customers />} />
              <Route path="/products" element={<Products />} />

              <Route path="/quotes" element={<DocumentList kind="quote" />} />
              <Route path="/quotes/new" element={<DocumentForm kind="quote" />} />
              <Route path="/quotes/:id" element={<DocumentView kind="quote" />} />
              <Route path="/quotes/:id/edit" element={<DocumentForm kind="quote" />} />

              <Route path="/invoices" element={<DocumentList kind="invoice" />} />
              <Route path="/invoices/new" element={<DocumentForm kind="invoice" />} />
              <Route path="/invoices/:id" element={<DocumentView kind="invoice" />} />
              <Route path="/invoices/:id/edit" element={<DocumentForm kind="invoice" />} />

              <Route path="/settings" element={<Settings />} />
              <Route path="/payment/success" element={<PaymentResult />} />
              <Route path="/payment/cancel" element={<PaymentResult cancelled />} />
            </Routes>
          </Layout>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </I18nProvider>
    </div>
  );
}

export default App;
